if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
        
        // Ensure modal content exists
        if (!this.modalContent) {
          console.error('Quick Add Modal: Modal content not found');
        }
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        console.log('Quick Add Modal: Opening modal');
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        const spinner = opener.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

            // Get product data from the button's data attributes
            const productUrl = opener.getAttribute('data-product-url');
            const productCard = opener.closest('.card');
            const productTitle = productCard.querySelector('.card__heading a')?.textContent || 'Product';
            const priceElement = productCard.querySelector('.price');
            let productPrice = '';
            if (priceElement) {
              // Extract just the price number, removing "Regular price", "Sale price", "Unit price / per" etc.
              const priceText = priceElement.textContent || '';
              const priceMatch = priceText.match(/\$[\d,]+\.?\d*/);
              productPrice = priceMatch ? priceMatch[0] : priceText;
            }
            const productImage = productCard.querySelector('.card__media img')?.src || '';
            
            // Clone the product card for the left side
            const clonedCard = productCard.cloneNode(true);
            // Remove the quick-add button from the cloned card
            const quickAddButton = clonedCard.querySelector('.quick-add__submit, .card--horizontal__quick-add');
            if (quickAddButton) {
              quickAddButton.remove();
            }

        // Fetch product data to get characteristics and product form
        fetch(productUrl)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            
            // Extract characteristics from the product page
            const characteristics = this.extractCharacteristics(responseHTML);
            
            // Extract product form with variant selection
            const productForm = this.extractProductForm(responseHTML);
            
            // Create modal content with characteristics and product form
            this.modalContent.innerHTML = `
              <div class="quick-add-simple">
                <div class="quick-add-left">
                  ${clonedCard.outerHTML}
                </div>
                <div class="quick-add-right">
                  ${characteristics}
                  ${productForm}
                  <div class="quick-add-message">
                    <div class="quick-add-buttons">
                      <a href="${productUrl}" class="button button--primary">
                        View Product Details
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            `;
            
            // Load the CSS file after the modal is created
            const link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = `${window.Shopify?.routes?.root || ''}/cdn/shop/t/10/assets/LPS-section-prod-details.css`;
            link.type = 'text/css';
            link.media = 'all';
            document.head.appendChild(link);

            // Show the modal
            super.show(opener);
            
            // Initialize variant selection and form handling
            this.initializeProductForm();
          })
          .catch((error) => {
            console.error('Quick Add Error:', error);
            // Fallback to simple modal without characteristics
            this.modalContent.innerHTML = `
              <div class="quick-add-simple">
                <div class="quick-add-left">
                  ${clonedCard.outerHTML}
                </div>
                <div class="quick-add-right">
                  <div class="quick-add-message">
                    <div class="quick-add-buttons">
                      <a href="${productUrl}" class="button button--primary">
                        View Product Details
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            `;
            super.show(opener);
          })
          .finally(() => {
            // Clean up loading state
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            if (spinner) spinner.classList.add('hidden');
          });
      }

      extractCharacteristics(responseHTML) {
        // Look for the LPS characteristics section and return it as-is
        const characteristicsSection = responseHTML.querySelector('.lps-product-characteristics, [id*="lps-product-characteristics"]');
        
        if (characteristicsSection) {
          // Clone the section and return it with its original styling
          const clonedSection = characteristicsSection.cloneNode(true);
          
          // Add a wrapper class for modal styling
          const wrapper = document.createElement('div');
          wrapper.className = 'quick-add-characteristics-wrapper';
          wrapper.appendChild(clonedSection);
          
          return wrapper.outerHTML;
        }
        
        return '';
      }

      extractProductForm(responseHTML) {
        // Look for the product form with variant selection
        const productForm = responseHTML.querySelector('product-form');
        
        if (productForm) {
          // Clone the product form
          const clonedForm = productForm.cloneNode(true);
          
          // Add a wrapper class for modal styling
          const wrapper = document.createElement('div');
          wrapper.className = 'quick-add-product-form-wrapper';
          wrapper.appendChild(clonedForm);
          
          return wrapper.outerHTML;
        }
        
        return '';
      }

      initializeProductForm() {
        // Initialize variant selection
        const variantSelects = this.modalContent.querySelector('variant-selects');
        if (variantSelects) {
          // Ensure variant selection works in the modal
          variantSelects.addEventListener('change', this.onVariantChange.bind(this));
        }

        // Initialize variant pills to work as selectors
        this.initializeVariantPills();

        // Initialize product form submission
        const productForm = this.modalContent.querySelector('product-form');
        if (productForm) {
          // The product-form component should handle the form submission automatically
          console.log('Product form initialized in quick-add modal');
        }
      }

      initializeVariantPills() {
        // Find all variant pills in the modal
        const variantPills = this.modalContent.querySelectorAll('.card-variants .variant-pill, .variant-picker__button');
        
        variantPills.forEach(pill => {
          // Remove any existing click handlers
          pill.onclick = null;
          
          // Add click handler for variant selection
          pill.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            
            // Remove active class from all pills in the same group
            const group = pill.closest('.card-variants, .variant-picker__buttons');
            if (group) {
              group.querySelectorAll('.variant-pill, .variant-picker__button').forEach(p => {
                p.classList.remove('active', 'selected');
                p.setAttribute('aria-pressed', 'false');
              });
            }
            
            // Add active class to clicked pill
            pill.classList.add('active', 'selected');
            pill.setAttribute('aria-pressed', 'true');
            
            // Get the variant ID from the pill
            const variantId = pill.getAttribute('data-variant-id') || 
                             pill.getAttribute('value') || 
                             pill.textContent.trim();
            
            // Update the hidden variant input if it exists
            const variantInput = this.modalContent.querySelector('input[name="id"]');
            if (variantInput) {
              variantInput.value = variantId;
            }
            
            // Update the selected variant
            this.selectedVariantId = variantId;
            
            console.log('Selected variant:', variantId);
          });
        });
      }

      onVariantChange(event) {
        // Handle variant change - update price, availability, etc.
        const variantSelects = event.target.closest('variant-selects');
        if (!variantSelects) return;

        // Get the selected variant ID
        const selectedVariantId = variantSelects.querySelector('[name="id"]:checked')?.value;
        if (!selectedVariantId) return;

        // Update price if available
        this.updatePrice(selectedVariantId);
      }

      updatePrice(variantId) {
        // This would typically fetch variant data and update the price
        // For now, we'll just log it
        console.log('Selected variant ID:', variantId);
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        console.log('Quick Add Modal: Removing unwanted DOM elements...');
        
        // Remove USPs and other unwanted content first
        const uspBlocks = this.productElement.querySelectorAll('[data-block-type="lps-product-usps"], [class*="lps-product-usps"], [class*="usp"]');
        if (uspBlocks.length > 0) {
          console.log(`Removing ${uspBlocks.length} USP blocks`);
          uspBlocks.forEach((block) => block.remove());
        }

        // Remove complementary products
        const complementaryProducts = this.productElement.querySelectorAll('product-recommendations, [class*="complementary"]');
        if (complementaryProducts.length > 0) {
          console.log(`Removing ${complementaryProducts.length} complementary products`);
          complementaryProducts.forEach((comp) => comp.remove());
        }

        // Remove share button
        const shareButton = this.productElement.querySelectorAll('share-button, [class*="share"]');
        if (shareButton.length > 0) {
          console.log(`Removing ${shareButton.length} share buttons`);
          shareButton.forEach((btn) => btn.remove());
        }

        // Remove collapsible tabs (accordions)
        const accordions = this.productElement.querySelectorAll('.accordion, [class*="accordion"]');
        if (accordions.length > 0) {
          console.log(`Removing ${accordions.length} accordions`);
          accordions.forEach((accordion) => accordion.remove());
        }

        // Remove product description if it's too long
        const description = this.productElement.querySelector('.product__description');
        if (description && description.textContent.length > 200) {
          console.log('Removing long product description');
          description.remove();
        }

        // Remove pickup availability
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) {
          console.log('Removing pickup availability');
          pickupAvailability.remove();
        }

        // Remove product modal
        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) {
          console.log('Removing product modal');
          productModal.remove();
        }

        // Remove modal dialogs
        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog.length > 0) {
          console.log(`Removing ${modalDialog.length} modal dialogs`);
          modalDialog.forEach((modal) => modal.remove());
        }
        
        console.log('Quick Add Modal: DOM cleanup complete');
      }

      preventDuplicatedIDs() {
        // Get section ID from the original section, not the product element
        const originalSection = document.querySelector('section[id^="MainProduct-"]');
        if (originalSection && originalSection.dataset.section) {
          const sectionId = originalSection.dataset.section;
          this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
          this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
            element.dataset.originalSection = sectionId;
          });
        }
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        if (!product || !product.classList) return;
        
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
